import * as React from 'react';
import { SVGProps } from 'react';

const IcBorderline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={24}
    fill="none"
    {...props}
  >
    <rect width={24} height={24} x={0.667} fill="#FFF6D7" rx={12} />
    <path
      fill="#866104"
      fillRule="evenodd"
      d="M20.09 13.5a2 2 0 0 0 0-2l-2.846-4.928a2 2 0 0 0-1.732-1h-5.69a2 2 0 0 0-1.733 1L5.244 11.5a2 2 0 0 0 0 2l2.845 4.928a2 2 0 0 0 1.732 1h5.691a2 2 0 0 0 1.732-1l2.845-4.928ZM12.666 9a.75.75 0 0 0-.745.662l-.005.088v3a.75.75 0 0 0 1.494.088l.006-.088v-3a.75.75 0 0 0-.75-.75Zm0 5.25a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z"
      clipRule="evenodd"
    />
  </svg>
);

export default IcBorderline;
